/**
 * API to interact with StackMap
 */

import { jsonp, createQueryString } from '@bibliocommons/utils-http';

/**
 * Fetch map data from StackMap
 * @param {string} domain
 * @param {object} data
 * @param {string} data.library - Branch name
 * @param {string} data.location - Collection
 * @param {string} data.callno - Call Numbers
 * @returns {Observable}
 */
function fetchMap(domain, data) {
  const queryString = createQueryString(data);
  const url = `https://${domain}.stackmap.com/json/?${queryString}&callback=`;
  return jsonp(url);
}

export default {
  fetchMap
};
